export const AppLogo = () => (
  <svg
    viewBox="0 0 32 32"
    className="size-8 shrink-0"
    role="img"
    aria-label="Colmeia"
  >
    <title>Colmeia</title>
    <path d="M16,16 L8.5,3.01 L23.5,3.01 L31,16 Z" fill="var(--primary)" />
    <path d="M16,16 L8.5,28.99 L1,16 L8.5,3.01 Z" fill="var(--chart-4)" />
    <path d="M16,16 L31,16 L23.5,28.99 L8.5,28.99 Z" fill="var(--chart-5)" />
  </svg>
);
